import { Component, inject, output } from '@angular/core';

import { Router } from '@angular/router';
import { LoginFormComponent } from '@ui/components/login-form.component';

@Component({
  imports: [LoginFormComponent],
  selector: 'fl-fo-login',
  template: `
    <div class="p-4 w-[420px]">
      <div class="text-xl font-semibold mb-4 text-center flex items-center justify-center gap-2">
        <em class="pi pi-lock text-green-700 text-2xl"></em>
        Area Riservata
      </div>
      <fl-login-form (register)="onRegister()" (login)="onLogin()" />
    </div>
  `,
})
export class LoginComponent {
  private router = inject(Router);

  register = output<void>();
  login = output<void>();

  onRegister() {
    this.router.navigate(['/registrazione']).then(() => {
      this.register.emit();
    });
  }

  onLogin() {
    this.router.navigate(['/private/dashboard']).then(() => {
      this.login.emit();
    });
  }
}
